export default __webpack_public_path__ + "_/shared/assets/images/invoicing/connectToQuickbooks.png";